import { useTheme } from "../../../../theme/ThemeProvider";
import { Img } from "../Img";

interface ILogoProps {
  className?: string;
}

const Logo: React.FC<ILogoProps> = ({ className = "" }) => {
  const { theme } = useTheme();
  return <Img src={`${theme}-logo.svg`} className={className} />;
};
export { Logo };
